export const base_url = "https://backendhostel.onrender.com/api/v1/";
